import { Component, HostListener, OnInit, ElementRef, ViewChild } from '@angular/core';
import { Router, NavigationEnd, RouterLink } from '@angular/router';
import { RouterModule } from '@angular/router';
import { filter } from 'rxjs/operators';
import { CommonModule } from '@angular/common';
import { IconsFreeToolsComponent } from '../icons-free-tools/icons-free-tools.component';
import { TranslateService } from '@ngx-translate/core';
import { TranslateModule } from '@ngx-translate/core';
import { LanguageService } from '../services/language.service';
import {
  SUPPORTED_LANGUAGES,
  DEFAULT_LANGUAGE,
} from '../config/language.config';
import { NavigationStart } from '@angular/router';
import { ApidataService } from '../apidata.service';
@Component({
  selector: 'app-footer',
  standalone: true,
  imports: [
    RouterModule,
    CommonModule,
    IconsFreeToolsComponent,
    TranslateModule,
  ],
  templateUrl: './footer.component.html',
  styleUrl: './footer.component.css',
})
export class FooterComponent implements OnInit {

  profile_id = localStorage.getItem('profile_id') || '1';
  defaultLang = DEFAULT_LANGUAGE;

  defaultLanguage = {
    name: 'English ',
    icon: '/assets/images/plagiarism checker1/language.svg',
    code: 'en',
  };
  startYear: number;
  endYear: number;
  dateRange: string;
  private readonly LANGUAGE_KEY = 'selectedLanguage';
  languages = this.languageService.languages;
  selectedLanguage: any;
  supportedLanguages = SUPPORTED_LANGUAGES;

  constructor(
    private router: Router,
    private translate: TranslateService,
    private languageService: LanguageService,
    private ApidataService: ApidataService
  ) {
    this.router.events
      .pipe(filter((event) => event instanceof NavigationEnd))
      .subscribe(() => {
        window.scrollTo({ top: 0, behavior: 'smooth' });
      });

    this.translate.setDefaultLang('en');
  }

  ngOnInit() {
    const langCode = this.languageService.getLanguageFromUrl(this.router.url);
    const lang = this.languageService.languages.find(
      (l) => l.code === langCode
    );
    if (lang) {
      this.languageService.setLanguage(lang);
    }

    this.languageService.selectedLanguage$.subscribe((language) => {
      this.selectedLanguage = language;
      this.translate.use(language.code);
    });

    const storedLanguage = localStorage.getItem('selectedLanguage');

    if (storedLanguage) {
      this.selectedLanguage = JSON.parse(storedLanguage);
      this.translate.use(this.selectedLanguage.code);
    } else {
      // this.translate.use('en');
    }

    this.startYear = 2011;
    this.endYear = new Date().getFullYear();
    this.dateRange = `${this.startYear} - ${this.endYear}`;
  }
  // objects objects

  content = [
    {
      icon: 'logoIcon',
      url: 'https://www.grammarin.com/',
    },
    {
      icon: '',
      paragraph: `GrammarIn is the gateway to ensuring perfection in written communication.
                   We have trained this utility on advanced algorithms and modern language rules
                   to assist you in proofreading textual documents and making them flawless.`,
    },
  ];

  companyLinks = [
    { label: 'About', routerLink: '/about-us', hasLink: true },
    { label: 'Contact', routerLink: '/contact-us', hasLink: true },
    { label: 'Contact Sales', routerLink: '', hasLink: false },
    { label: 'Handbook', routerLink: '/handbook', hasLink: true },
    { label: 'Security', routerLink: '', hasLink: false },
    { label: 'Pricing', routerLink: '/pricing', hasLink: true },
    { label: 'Help', routerLink: '/help-center', hasLink: true },
  ];
  links = [
    {
      label: 'Terms & Conditions',
      routerLink: '/terms-conditions',
      hasLink: true,
    },
    { label: 'Privacy Policy', routerLink: '/privacy-policy', hasLink: true },
    { label: 'Privacy Disclosure', routerLink: '', hasLink: false },
    { label: 'Security', routerLink: '', hasLink: false },
  ];
  premiumTools = [
    { name: 'Grammar Checker', routerLink: '/grammar-checker' },
    { name: 'Punctuation Checker', routerLink: '/punctuation-checker' },
    { name: 'Plagiarism Checker', routerLink: '/plagiarism-checker' },
    { name: 'Paraphrasing Tool', routerLink: '/paraphrasing-tool' },
    { name: 'Text Summarizer', routerLink: '/text-summarizer' },
    { name: 'AI Text Detector', routerLink: '/ai-content-detector' },
    { name: 'Article Rewriter', routerLink: '/article-rewriter' },
    { name: 'Sentence Checker', routerLink: '/sentence-checker' },
    { name: 'Essay Checker', routerLink: '/essay-checker' },
    { name: 'Online Proofreader', routerLink: '/online-proofreader' },
    { name: 'AI Writing Tools', routerLink: '/ai-writing-tools' },
  ];
  aiTools = [
    { name: 'AI Job Description', route: '/ai-job-description' },
    { name: 'AI Business Plan', route: '/ai-business-plan' },
    { name: 'AI Summarizer', route: '/ai-summarizer' },
    { name: 'AI Paragraph Generator', route: '/ai-paragraph' },
    { name: 'AI Letter Writer', route: '/ai-letter-writer' },
    { name: 'AI Article Writer', route: '/ai-article-writer' },
    { name: 'IELTS / TOFEL Grading', route: '/grading' },
  ];
  socialMediaLinks = [
    {
      icon: 'instaIcon',
      url: 'https://www.instagram.com/grammar_in/',
      alt: 'Instagram',
    },
    {
      icon: 'linedinIcon',
      url: 'https://www.linkedin.com/uas/login?session_redirect=https%3A%2F%2Fwww.linkedin.com%2Fcompany%2F65443935%2Fadmin%2F',
      alt: 'LinkedIn',
    },
  ];
  // objects objects

  selectLanguage(language) {
    this.languageService.setLanguage(language);
    localStorage.setItem(
      'selectedLanguage',
      JSON.stringify(this.selectedLanguage)
    );
    this.translate.use(language.code);

    this.profile_id !== '1' &&
      this.ApidataService
        .updateUserLanguage(this.profile_id, language.code === "en" ? "en-us" : language.code)
        .subscribe();

    this.isMenuOpen = null;

    const currentUrl = this.router.url;
    const segments = currentUrl.split('/');

    if (this.languageService.languages.some((l) => l.code === segments[1])) {
      segments.splice(1, 1);
    }

    const newUrl =
      language.code === 'en'
        ? '/' + segments.slice(1).join('/')
        : '/' + language.code + '/' + segments.slice(1).join('/');

    this.router.navigateByUrl(newUrl);



    this.router.events.subscribe((event) => {
      if (event instanceof NavigationStart) {
        let url = event.url;

        if (url !== '/' && url.endsWith('/')) {
          url = url.slice(0, -1);
          this.router.navigateByUrl(url);
          return;
        }

        if (url === '/' || url === '') {
          const selectedLang = this.selectedLanguage?.code || 'en';
          if (selectedLang !== 'en') {
            this.router.navigateByUrl(`/${selectedLang}`);

          }
        }

      }
    });

  }

  isMenuOpen = false;

  toggleMenu() {
    this.isMenuOpen = !this.isMenuOpen;
  }
  activeDropdown: string = '';
  @HostListener('document:click', ['$event'])
  onClickOutside(event: Event) {
    const dropdowns = document.querySelectorAll(
      '.dropdown-container, .menu-btn'
    );

    let isInside = false;
    dropdowns.forEach((dropdown) => {
      if (dropdown.contains(event.target as Node)) {
        isInside = true;
      }
    });

    if (!isInside) {
      this.activeDropdown = '';
    }
  }
  @ViewChild('dropdownRef') dropdownRef!: ElementRef;
  @HostListener('document:click', ['$event'])
  onDocumentClick(event: MouseEvent) {
    const clickedInside = this.dropdownRef.nativeElement.contains(event.target);
    if (!clickedInside) {
      this.isMenuOpen = false;
    }
  }

  allowedRoutes: string[] = ['/', '/es', '/pt', '/grammar-checker', '/pt/grammar-checker', '/es/grammar-checker'];
  shouldShowLanguageDropdown(): boolean {
    const currentUrl = this.router.url;
    return this.allowedRoutes.includes(currentUrl);
  }
}
